var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import cx from 'clsx';
import { baseGapVariants, responsiveGapVariants } from '../../css/responsiveWhitespace.css';
import { collapseBaseStyles, collapseVariants } from '../../css/layout.css';
import { getSpacingClasses } from '../../utils/spacings';
import { alignVariants, baseStyles, verticalAlignVariants, wrapVariants } from './Inline.css';
export const Inline = React.forwardRef(function Inline(_a, ref) {
    var { align, alignY, as, children, className, collapseBelow, spacing = 16, noWrap = false } = _a, rest = __rest(_a, ["align", "alignY", "as", "children", "className", "collapseBelow", "spacing", "noWrap"]);
    const Component = as || 'div';
    const spacingClass = getSpacingClasses(spacing, baseGapVariants, responsiveGapVariants);
    return (_jsx(Component, Object.assign({}, rest, { className: cx(baseStyles, collapseBelow && [collapseBaseStyles, collapseVariants[collapseBelow]], spacingClass, align && alignVariants[align], alignY && verticalAlignVariants[alignY], wrapVariants[noWrap ? 'noWrap' : 'wrap'], className), ref: ref, children: children })));
});
